module.exports = __webpack_public_path__ + "static/media/Twitter.88248faf.svg";